import React from 'react'
import Modal from 'react-modal';
import './HowToPlayModal.css'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const HowToPlayModalModal = (props: any) => {
  const modalClassName = props.isOpen ? 'modalHowToPlay active' : 'modalHowToPlay';
  const { i18n, t } = useTranslation();

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onClose}
      contentLabel="HowToPlay Modal"
      ariaHideApp={false}
      className={modalClassName}
    >   
        <div className='howToPlayContainer'>
            <button onClick={props.onClose} className="close-button">×</button>
            <h1>{t('modal-play.title')}</h1>
            <div className='howToPlay'>
                <span>{t('modal-play.second')}</span>
                <br /><br />
                <span>{t('modal-play.lives')}</span>
                <br /><br />
                <span>{t('modal-play.finished')}</span>
                <br /><br />
            </div>
            <h1 className='lolboard'>{t('modal-play.lolboard')}</h1>
        </div>
    </Modal>
  );
};